"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionalTimer = void 0;
/**
 * Port of GWT's timer mechanism / class.
 */
class Timer {
    constructor() {
        this.timerId = undefined;
    }
    /**
     * Returns true if the timer is running. Timer is running if and only if it is scheduled but it is not expired or cancelled.
     */
    isRunning() {
        return !!this.timerId;
    }
    /**
     * Cancels this timer. If the timer is not running, this is a no-op.
     */
    cancel() {
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = undefined;
        }
    }
    /**
     * Schedules a timer to elapse in the future. If the timer is already running then it will be first canceled before re-scheduling.
     * @delayMilliseconds how long to wait before the timer elapses, in milliseconds - if omitted will run "immediately"
     */
    schedule(delayMilliseconds = 0) {
        this.cancel();
        this.timerId = window.setTimeout(() => {
            this.run();
        }, delayMilliseconds);
    }
    /**
     * Schedules a timer that elapses repeatedly. If the timer is already running then it will be first canceled before re-scheduling.
     * @periodMilliseconds how long to wait before the timer elapses, in milliseconds, between each repetition
     */
    scheduleRepeating(periodMilliseconds) {
        this.cancel();
        this.timerId = window.setInterval(() => {
            this.run();
        }, periodMilliseconds);
    }
}
class FunctionalTimer extends Timer {
    constructor(func) {
        super();
        this.func = func;
    }
    run() {
        this.func();
    }
}
exports.FunctionalTimer = FunctionalTimer;
exports.default = Timer;
//# sourceMappingURL=Timer.js.map